import _ from 'lodash';

import React from 'react';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import Warning from 'components/Warning';

import {MODALS, storeDataInModal} from 'ducks/modals';

import './styles.css';

interface ConfirmationModal {
  className?: string;
  closeModal: (any) => {};
  data: {
    showQuestionOnError?: boolean;
    heading?: string;
    question?: string;
    errors?: any;
    warnings?: any;
    confirmAction: () => {};
    submitting?: boolean;
    cancelButtonText?: string;
    confirmButtonText?: string;
    danger?: boolean;
  };
  storeDataInModal: ({modalName: string, data: any}) => void;
}

const ConfirmationModal = ({
  className,
  closeModal,
  data: {
    showQuestionOnError = false,
    heading = 'Confirmation Modal',
    question = 'Are you sure?',
    errors,
    warnings = [],
    confirmAction,
    submitting,
    cancelButtonText = 'No',
    confirmButtonText = 'Yes',
    danger
  },
  storeDataInModal
}: ConfirmationModal) => {
  const confirm = () => {
    // We set submitting=false when we display an error. Otherwise the modal data is cleared on close.
    storeDataInModal({modalName: MODALS.CONFIRM, data: {submitting: true}});
    confirmAction();
  };

  return (
    <Modal
      className={classNames('ConfirmationModal', {className})}
      show={true}
      type={Modal.EXTRA_SMALL}
      onClose={closeModal}>
      <Modal.Header heading={heading} />
      <Modal.Body>
        {!_.isEmpty(warnings) &&
          warnings.map(warning => <Warning key={warning}>{warning}</Warning>)}
        {_.get(errors, '_error') && <ErrorBlock>{errors._error}</ErrorBlock>}
        {(_.isNil(errors) || showQuestionOnError) && (
          <div className="question">{question}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button white onClick={closeModal}>
          {cancelButtonText}
        </Button>
        <Button
          red={danger}
          blue={!danger && !submitting}
          disabled={submitting || errors}
          isLoading={submitting}
          onClick={confirm}>
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapDispatchToProps = {storeDataInModal};

export default connect(null, mapDispatchToProps)(
  withModal(MODALS.CONFIRM)(ConfirmationModal)
);
